import { Card, CardKind, LevelSim, OfferKind, scoutedHands } from "@highmarch/domain";
import { icon } from "../iconsKit";
import { pathIconUrl, portraitUrl } from "../portraits";
import { supplyIconHtml } from "./supplyArt";

/**
 * The Scout's Map in battle (MP-06): under the tray's road line, while an in-run hand is open, the next hands read
 * ahead (domain sim/scout.ts: the same plan and draws the sim will deal, on the board as it stands) — each a small group
 * of card faces: a tower's portrait, a road piece's icon, the Upgrade chevron. A pure read: it never touches the run.
 * Nothing shows without the map, in the opening draft, during a rare's rally, or while a card is being placed.
 */

const FACE_PX = 22;

function face(sim: LevelSim, c: Card): string {
  if (c.kind === CardKind.Upgrade) return `<i class="sc up" title="Upgrade">${icon("chev", 14, "#ffd75c", 3)}</i>`;
  if (c.kind === CardKind.Move) return `<i class="sc move" title="Move a tower">${icon("turn_right", 14, "#9fd8ee", 2.6)}</i>`;
  if (c.kind === CardKind.Path) {
    const s = sim.balance.cards.shapes[c.index];
    return `<i class="sc road" title="${s.name}"><img decoding="sync" src="${pathIconUrl(s.id)}" alt="" width="${FACE_PX}" height="${FACE_PX}"></i>`;
  }
  if (c.kind === CardKind.Tower) {
    const t = sim.balance.towers[c.index], url = portraitUrl(t.id);
    return `<i class="sc tower" title="${t.name}">${url ? `<img decoding="sync" src="${url}" alt="" width="${FACE_PX}" height="${FACE_PX}">` : icon("tower", 14)}</i>`;
  }
  return "";
}

export class ScoutStrip {
  private readonly el: HTMLDivElement;
  private key = "";

  constructor(tray: HTMLElement) {
    this.el = document.createElement("div");
    this.el.className = "scoutstrip hidden";
    this.el.setAttribute("aria-label", "Scout's Map: your next hands");
    tray.querySelector(".cards")?.before(this.el);
  }

  refresh(sim: LevelSim): void {
    const offer = sim.currentOffer;
    const show = (sim.mods.supplies?.scout ?? 0) > 0 && offer !== null && offer.kind === OfferKind.PostWave && !offer.rare && !offer.hasPick;
    this.el.classList.toggle("hidden", !show);
    if (!show) { this.key = ""; return; }
    // the board, the hand and the stream decide what is read ahead: redraw only when one of them moved
    const key = `${offer.id}|${offer.cards.length}|${sim.rng.stateValue}|${sim.road.designedTileCount}|${sim.towerSlots.filter((t) => t.alive).length}|${sim.offersSinceTowers}|${sim.offersSinceUpgrade}|${sim.offersSinceRoad}`;
    if (key === this.key) return;
    this.key = key;
    const hands = scoutedHands(sim);
    const groups = hands.map((h, i) => `<span class="sh" aria-label="Hand ${i + 2}">${h.cards.map((c) => face(sim, c)).join("")}</span>`).join(`<i class="ssep" aria-hidden="true"></i>`);
    this.el.innerHTML = `<span class="slbl">${supplyIconHtml("scoutsMap", 20)}<b class="disp">NEXT</b></span>${groups || `<small>No more hands foreseen</small>`}`;
  }
}
